/* Amber Oud — shop interactions: card add/options, quick-view, floating pill, AJAX cart */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var S = document.querySelector('[data-ao-strings]');
  var STR = S ? S.dataset : { add: 'Add to cart', options: 'Options', soldout: 'Sold out', added: 'Added ✓' };

  /* ---------------- AJAX cart ---------------- */
  function cartDrawerEl() { return document.querySelector('cart-drawer'); }

  function addToCart(variantId, qty, onDone) {
    // 1) Add the item. Keep the request minimal (some stores omit `sections`
    //    from the add response); we refresh the cart UI separately, reliably.
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: qty || 1 })
    })
      .then(function (r) { return r.json().then(function (res) { return { ok: r.ok, res: res }; }); })
      .then(function (o) {
        if (!o.ok || o.res.status) { if (onDone) onDone(false, o.res); return; }
        refreshCart(variantId, function () {
          document.dispatchEvent(new CustomEvent('ao:cart:added', { detail: o.res }));
          if (onDone) onDone(true, o.res);
        });
      })
      .catch(function () { if (onDone) onDone(false); });
  }

  /* Pull freshly-rendered cart sections via the Section Rendering API and
     update the drawer + cart bubble, then open the drawer. Reliable across
     stores regardless of what the add response includes. */
  function refreshCart(variantId, done) {
    var drawer = cartDrawerEl();
    var ids = ['cart-icon-bubble'];
    if (drawer) ids.unshift('cart-drawer');
    fetch(root + '?sections=' + ids.join(','), { cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (drawer && drawer.renderContents) {
          // The <cart-drawer> keeps `is-empty` from the initial empty render;
          // `.is-empty .cart__contents{display:none}` would hide the items list.
          drawer.classList.remove('is-empty');
          try { drawer.renderContents({ sections: sections, id: variantId }); }
          catch (e) { if (sections['cart-icon-bubble']) updateBubble(sections['cart-icon-bubble']); }
          drawer.classList.remove('is-empty');
          // Fallback open ONLY if renderContents didn't open it (avoids a double
          // trapFocus call that errors inside Dawn's getFocusableElements).
          setTimeout(function () {
            if (drawer.classList && !drawer.classList.contains('active') && drawer.open) {
              try { drawer.open(); } catch (e) {}
            }
          }, 120);
        } else if (sections['cart-icon-bubble']) {
          updateBubble(sections['cart-icon-bubble']);
        }
        if (done) done();
      })
      .catch(function () { if (done) done(); });
  }

  function updateBubble(html) {
    var b = document.getElementById('cart-icon-bubble');
    if (!b) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var src = doc.getElementById('cart-icon-bubble');
    if (src) b.innerHTML = src.innerHTML;
    b.classList.remove('hidden');
  }

  /* ---------------- Quick view ---------------- */
  var modal = document.querySelector('[data-ao-qv-modal]');
  var modalBody = modal && modal.querySelector('[data-ao-qv-body]');
  var lastFocus = null;

  function openModal() {
    if (!modal) return;
    lastFocus = document.activeElement;
    modal.hidden = false;
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
    document.body.classList.add('ao-modal-open');
    var panel = modal.querySelector('.ao-qv-modal__panel');
    if (panel) panel.focus();
  }
  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.classList.remove('ao-modal-open');
    setTimeout(function () { modal.hidden = true; if (modalBody) modalBody.innerHTML = '<div class="ao-qv-modal__spinner"></div>'; }, 280);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function quickView(url) {
    if (!modal || !modalBody) { window.location.href = url; return; }
    modalBody.innerHTML = '<div class="ao-qv-modal__spinner"></div>';
    openModal();
    var u = url.split('?')[0] + '?section_id=ao-quick-view&_fd=0&pb=0';
    var tries = 0;
    function attempt() {
      tries++;
      fetch(u, { cache: 'no-store', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          if (html.indexOf('data-ao-qv-root') === -1) return Promise.reject('empty');
          modalBody.innerHTML = html;
          initQuickView(modalBody);
        })
        .catch(function () {
          if (tries < 2) { setTimeout(attempt, 350); return; }
          closeModal();
          window.location.href = url; // graceful fallback to the product page
        });
    }
    attempt();
  }

  function initQuickView(scope) {
    var rootEl = scope.querySelector('[data-ao-qv-root]');
    if (!rootEl) return;
    var dataEl = rootEl.querySelector('[data-ao-qv-variants]');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
    var priceEl = rootEl.querySelector('[data-ao-qv-price]');
    var addBtn = rootEl.querySelector('[data-ao-qv-add]');
    var addLabel = rootEl.querySelector('[data-ao-qv-add-label]');
    var imageEl = rootEl.querySelector('[data-ao-qv-image]');
    var qtyInput = rootEl.querySelector('[data-ao-qv-qty-input]');
    var optGroups = rootEl.querySelectorAll('[data-ao-qv-opt]');

    function selectedOptions() {
      var sel = [];
      optGroups.forEach(function (g) {
        var active = g.querySelector('.ao-qv__chip.is-active');
        sel[Number(g.getAttribute('data-ao-qv-opt'))] = active ? active.getAttribute('data-value') : null;
      });
      return sel;
    }
    function matchVariant() {
      if (!variants.length) return null;
      if (!optGroups.length) return variants[0];
      var sel = selectedOptions();
      return variants.find(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      }) || null;
    }
    function refresh() {
      var v = matchVariant();
      if (!v) {
        addBtn.disabled = true;
        if (addLabel) addLabel.textContent = STR.soldout;
        return;
      }
      addBtn.setAttribute('data-variant', v.id);
      if (priceEl) priceEl.textContent = v.price;
      if (imageEl && v.image) imageEl.src = v.image;
      if (v.available) { addBtn.disabled = false; if (addLabel) addLabel.textContent = STR.add; }
      else { addBtn.disabled = true; if (addLabel) addLabel.textContent = STR.soldout; }
    }

    // Mark option values that have no available variant at all (out of stock)
    optGroups.forEach(function (g) {
      var gi = Number(g.getAttribute('data-ao-qv-opt'));
      g.querySelectorAll('[data-ao-qv-value]').forEach(function (chip) {
        var val = chip.getAttribute('data-value');
        var ok = variants.some(function (v) { return v.available && String(v.options[gi]) === String(val); });
        chip.classList.toggle('is-unavailable', !ok);
        chip.disabled = !ok;
      });
    });

    rootEl.querySelectorAll('[data-ao-qv-value]').forEach(function (chip) {
      chip.addEventListener('click', function () {
        if (chip.disabled) return;
        var group = chip.closest('[data-ao-qv-opt]');
        group.querySelectorAll('.ao-qv__chip').forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        refresh();
      });
    });
    rootEl.querySelectorAll('[data-ao-qv-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var d = Number(b.getAttribute('data-ao-qv-qty'));
        var n = Math.max(1, (parseInt(qtyInput.value, 10) || 1) + d);
        qtyInput.value = n;
      });
    });
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var id = addBtn.getAttribute('data-variant');
        if (!id || addBtn.disabled) return;
        var qty = Math.max(1, parseInt(qtyInput.value, 10) || 1);
        addBtn.classList.add('is-loading');
        addToCart(id, qty, function (ok) {
          addBtn.classList.remove('is-loading');
          if (ok) closeModal();
        });
      });
    }
    refresh();
  }

  /* ---------------- Card hover buttons ---------------- */
  function cardAction(el) {
    if (el.classList.contains('is-loading')) return; // prevent duplicate clicks
    var simple = el.getAttribute('data-simple') === 'true';
    var available = el.getAttribute('data-available') === 'true';
    if (!available) return;
    if (!simple) { quickView(el.getAttribute('data-url')); return; }
    var id = el.getAttribute('data-variant');
    if (!id) { quickView(el.getAttribute('data-url')); return; } // fall back to options if no variant
    el.classList.add('is-loading');
    el.setAttribute('aria-busy', 'true');
    if (el.tagName === 'BUTTON') el.disabled = true;
    addToCart(id, 1, function (ok, res) {
      el.classList.remove('is-loading');
      el.removeAttribute('aria-busy');
      if (el.tagName === 'BUTTON') el.disabled = false;
      if (ok) {
        el.classList.add('is-added');
        setTimeout(function () { el.classList.remove('is-added'); }, 1600);
      } else {
        el.classList.add('is-error');
        var msg = (res && (res.description || res.message)) || STR.soldout;
        el.setAttribute('title', msg);
        setTimeout(function () { el.classList.remove('is-error'); }, 2000);
      }
    });
  }

  /* ---------------- Inline variant picker (in-card, no modal) ----------------
     Lets the customer choose a variant and add to cart straight from the card.
     Reuses addToCart()/refreshCart() above — no duplicate cart logic. Fully
     delegation-driven so infinite-scroll-added cards work with no re-init. */
  function vpVariants(widget) {
    if (widget.__vp) return widget.__vp;
    var el = widget.querySelector('[data-ao-vp-variants]');
    var arr = [];
    try { arr = JSON.parse(el.textContent); } catch (e) {}
    widget.__vp = arr;
    return arr;
  }
  function vpGroups(widget) { return [].slice.call(widget.querySelectorAll('[data-ao-vp-opt]')); }
  function vpSelected(widget) {
    return vpGroups(widget).map(function (g) {
      var sel = g.querySelector('[data-ao-vp-select]');
      if (sel) return sel.value;
      var active = g.querySelector('.ao-vp__chip.is-active');
      return active ? active.getAttribute('data-value') : null;
    });
  }
  function vpMatch(widget) {
    var variants = vpVariants(widget);
    var sel = vpSelected(widget);
    return variants.find(function (v) {
      return v.options.every(function (o, i) { return String(o) === String(sel[i]); });
    }) || null;
  }
  function vpStr(widget, key, fallback) {
    var s = widget.querySelector('[data-ao-vp-str]');
    return (s && s.dataset[key]) || fallback;
  }
  function vpSync(widget) {
    var variants = vpVariants(widget);
    if (!variants.length) return;
    // Disable option values with no available variant at all (out-of-stock).
    vpGroups(widget).forEach(function (g) {
      var gi = Number(g.getAttribute('data-ao-vp-opt'));
      var avail = function (val) {
        return variants.some(function (v) { return v.available && String(v.options[gi]) === String(val); });
      };
      g.querySelectorAll('[data-ao-vp-value]').forEach(function (chip) {
        var ok = avail(chip.getAttribute('data-value'));
        chip.classList.toggle('is-unavailable', !ok);
        chip.disabled = !ok;
      });
      var selectEl = g.querySelector('[data-ao-vp-select]');
      if (selectEl) [].forEach.call(selectEl.options, function (opt) { opt.disabled = !avail(opt.value); });
    });
    var v = vpMatch(widget);
    var addBtn = widget.querySelector('[data-ao-vp-add]');
    var label = widget.querySelector('[data-ao-vp-add-label]');
    var priceSel = widget.getAttribute('data-ao-vp-price-sel');
    var card = widget.closest('[data-ao-card]');
    if (!addBtn) return;
    if (v && v.available) {
      addBtn.setAttribute('data-variant', v.id);
      addBtn.disabled = false;
      if (label) label.textContent = vpStr(widget, 'add', 'Add to cart');
      if (priceSel && card) { var pe = card.querySelector(priceSel); if (pe) pe.textContent = v.price; }
    } else {
      if (v) addBtn.setAttribute('data-variant', v.id);
      addBtn.disabled = true;
      if (label) label.textContent = vpStr(widget, 'soldout', 'Sold out');
    }
  }
  function vpInitAll(root) { (root || document).querySelectorAll('[data-ao-vp]').forEach(vpSync); }

  document.addEventListener('click', function (e) {
    // Inline variant picker: pick a value
    var vpValue = e.target.closest('[data-ao-vp-value]');
    if (vpValue) {
      e.preventDefault(); e.stopPropagation();
      if (vpValue.disabled) return;
      var group = vpValue.closest('[data-ao-vp-opt]');
      group.querySelectorAll('[data-ao-vp-value]').forEach(function (c) { c.classList.remove('is-active'); c.setAttribute('aria-pressed', 'false'); });
      vpValue.classList.add('is-active'); vpValue.setAttribute('aria-pressed', 'true');
      vpSync(vpValue.closest('[data-ao-vp]'));
      return;
    }
    // Inline variant picker: add to cart
    var vpAdd = e.target.closest('[data-ao-vp-add]');
    if (vpAdd) {
      e.preventDefault(); e.stopPropagation();
      if (vpAdd.disabled || vpAdd.classList.contains('is-loading')) return;
      var widget = vpAdd.closest('[data-ao-vp]');
      var m = vpMatch(widget);
      var id = vpAdd.getAttribute('data-variant');
      if (!m || !m.available || !id) return;
      vpAdd.classList.add('is-loading'); vpAdd.setAttribute('aria-busy', 'true'); vpAdd.disabled = true;
      addToCart(id, 1, function (ok) {
        vpAdd.classList.remove('is-loading'); vpAdd.removeAttribute('aria-busy'); vpAdd.disabled = false;
        if (ok) { vpAdd.classList.add('is-added'); setTimeout(function () { vpAdd.classList.remove('is-added'); }, 1600); }
        else { vpAdd.classList.add('is-error'); setTimeout(function () { vpAdd.classList.remove('is-error'); }, 2000); }
      });
      return;
    }
    var addBtn = e.target.closest('[data-ao-add]');
    if (addBtn) { e.preventDefault(); e.stopPropagation(); cardAction(addBtn); return; }
    if (e.target.closest('[data-ao-qv-close]')) { closeModal(); return; }
    var pillBtn = e.target.closest('[data-ao-pill-btn]');
    if (pillBtn && currentPillCard) { e.preventDefault(); cardAction(pillBtn); }
  });
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-ao-vp-select]');
    if (sel) vpSync(sel.closest('[data-ao-vp]'));
  });
  if (document.readyState !== 'loading') vpInitAll(); else document.addEventListener('DOMContentLoaded', function () { vpInitAll(); });
  if ('MutationObserver' in window) {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        [].forEach.call(m.addedNodes, function (n) {
          if (n.nodeType !== 1) return;
          if (n.matches && n.matches('[data-ao-vp]')) vpSync(n);
          else if (n.querySelectorAll) n.querySelectorAll('[data-ao-vp]').forEach(vpSync);
          // Newly injected product cards (infinite scroll etc.) get commerce revalidation
          if (n.matches && n.matches('[data-ao-card]')) { if (aoFreshIO) aoFreshIO.observe(n); }
          else if (n.querySelectorAll) n.querySelectorAll('[data-ao-card][data-url]').forEach(function (c) { if (aoFreshIO) aoFreshIO.observe(c); else aoFreshCard(c); });
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && !modal.hidden) closeModal();
  });

  /* ---------------- Commerce freshness revalidation ----------------
     Storefront HTML (pages, section renders) is served from Shopify's page
     cache for anonymous visitors and pods converge non-atomically, so the
     baked-in availability/price a browser receives can briefly be stale —
     and localStorage/bfcache can hold it far longer. This module re-checks
     the source of truth after render (cache: no-store defeats every
     browser-side layer) and corrects: add-to-cart state, sold-out labels,
     and displayed prices (compared via raw KWD cents baselines so we never
     fight the currency-converter app's display rewrites). Static content
     (images, copy) stays cached — only commerce state is revalidated. */
  var aoFreshCache = {};
  var aoFreshDone = (typeof WeakSet !== 'undefined') ? new WeakSet() : null;

  function aoFreshFetch(productUrl) {
    var base = String(productUrl || '').split('?')[0];
    if (!base) return Promise.resolve(null);
    if (aoFreshCache[base]) return aoFreshCache[base];
    var u = base + '?section_id=ao-quick-view&_fd=0&pb=0';
    aoFreshCache[base] = fetch(u, { cache: 'no-store', headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var rootEl = doc.querySelector('[data-ao-qv-root]');
        if (!rootEl) return null;
        var variants = [];
        try { variants = JSON.parse(rootEl.querySelector('[data-ao-qv-variants]').textContent); } catch (e) {}
        if (!variants.length) return null;
        var min = variants[0];
        variants.forEach(function (v) { if (v.cents < min.cents) min = v; });
        var fresh = {
          handle: rootEl.getAttribute('data-ao-qv-handle') || '',
          available: rootEl.getAttribute('data-ao-qv-available') === 'true',
          first: rootEl.getAttribute('data-ao-qv-first') || '',
          variants: variants,
          minCents: min.cents,
          minPrice: min.price,
          minCompare: (min.compare_cents > min.cents) ? min.compare : null
        };
        document.dispatchEvent(new CustomEvent('ao:fresh:product', { detail: { handle: fresh.handle, fresh: fresh } }));
        return fresh;
      })
      .catch(function () { delete aoFreshCache[base]; return null; });
    return aoFreshCache[base];
  }

  function aoFreshApplyCard(card, fresh) {
    if (!fresh) return;
    // Availability + add-to-cart state
    var wasAvailable = card.getAttribute('data-available') === 'true';
    if (fresh.available !== wasAvailable) {
      card.setAttribute('data-available', String(fresh.available));
      if (fresh.available && fresh.first) card.setAttribute('data-variant', fresh.first);
      card.querySelectorAll('.ao-card__add[data-ao-add]').forEach(function (b) {
        b.setAttribute('data-available', String(fresh.available));
        if (fresh.available && fresh.first) b.setAttribute('data-variant', fresh.first);
        b.disabled = !fresh.available;
        // The hover overlay button is hidden when sold out (matches server render)
        if (b.classList.contains('ao-card__add--over')) b.classList.toggle('ao-card__add--soldout', !fresh.available);
        var label = b.querySelector('.ao-card__add-label');
        if (label) {
          if (!fresh.available) label.textContent = STR.soldout;
          else label.textContent = (b.getAttribute('data-simple') === 'true') ? STR.add : STR.options;
        }
      });
    }
    // Price (raw store-currency cents comparison; skip if no baseline)
    var baseCents = parseInt(card.getAttribute('data-price-cents'), 10);
    if (!isNaN(baseCents) && typeof fresh.minCents === 'number' && fresh.minCents !== baseCents) {
      var nowEl = card.querySelector('.ao-bs__card-price-now') ||
        card.querySelector('.ao-search__card-price') ||
        card.querySelector('.price-item--sale:not(.hidden)') ||
        card.querySelector('.price-item--regular');
      if (nowEl) nowEl.textContent = fresh.minPrice;
      card.setAttribute('data-price-cents', String(fresh.minCents));
      card.setAttribute('data-price', fresh.minPrice);
      var cmp = card.querySelector('.ao-bs__card-compare');
      if (fresh.minCompare) {
        if (!cmp) {
          var wrap = card.querySelector('.ao-bs__card-price');
          if (wrap) { cmp = document.createElement('s'); cmp.className = 'ao-bs__card-compare'; wrap.appendChild(cmp); }
        }
        if (cmp) cmp.textContent = fresh.minCompare;
      } else if (cmp) { cmp.remove(); }
    }
  }

  function aoFreshCard(card) {
    if (aoFreshDone) { if (aoFreshDone.has(card)) return; aoFreshDone.add(card); }
    var url = card.getAttribute('data-url');
    if (!url || url === '#') return;
    aoFreshFetch(url).then(function (fresh) { aoFreshApplyCard(card, fresh); });
  }

  var aoFreshIO = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { aoFreshIO.unobserve(en.target); aoFreshCard(en.target); }
    });
  }, { rootMargin: '250px' }) : null;

  function aoFreshScan(rootNode) {
    (rootNode || document).querySelectorAll('[data-ao-card][data-url]').forEach(function (card) {
      if (aoFreshIO) aoFreshIO.observe(card); else aoFreshCard(card);
    });
  }

  function aoFreshPDP() {
    var item = window.AO_RECENT_ITEM; // set only on product pages
    if (!item || !item.handle) return;
    var mainBtn = document.querySelector('.product-form__submit') ||
      document.querySelector('product-form button[type="submit"]');
    if (!mainBtn) return;
    aoFreshFetch(item.url || (root + 'products/' + encodeURIComponent(item.handle))).then(function (fresh) {
      if (!fresh) return;
      var idInput = document.querySelector('form[action*="/cart/add"] input[name="id"], product-info input[name="id"]');
      var vid = idInput ? String(idInput.value) : String(item.variant);
      var v = null;
      fresh.variants.forEach(function (x) { if (String(x.id) === vid) v = x; });
      var isAvail = v ? v.available : fresh.available;
      var label = mainBtn.querySelector('span') || mainBtn;
      if (!isAvail && !mainBtn.disabled) { mainBtn.disabled = true; label.textContent = STR.soldout; }
      else if (isAvail && mainBtn.disabled) { mainBtn.disabled = false; label.textContent = STR.add; }
      // Price: patch only when the current selection is the baseline variant
      // and the raw cents actually changed (never rewrites converted currency
      // unless the source price truly moved).
      if (v && String(item.variant) === vid && typeof item.cents === 'number' && v.cents !== item.cents) {
        var pe = document.querySelector('.product__info-wrapper .price-item--sale:not(.hidden), .product__info-wrapper .price-item--regular, .product__info-container .price-item--regular');
        if (pe) pe.textContent = v.price;
      }
    });
  }

  function aoFreshReset() {
    aoFreshCache = {};
    aoFreshDone = (typeof WeakSet !== 'undefined') ? new WeakSet() : null;
  }
  function aoFreshRun() { aoFreshScan(document); aoFreshPDP(); }

  if (document.readyState !== 'loading') aoFreshRun();
  else document.addEventListener('DOMContentLoaded', aoFreshRun);
  // Cards rendered later (recently-viewed grid) announce themselves
  document.addEventListener('ao:fresh:scan', function (e) {
    aoFreshScan((e.detail && e.detail.root) || document);
  });
  // Back/forward-cache restores show the old DOM — revalidate it
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) { aoFreshReset(); aoFreshRun(); }
  });
  // Tab left open a long time, then refocused — revalidate
  var aoHiddenAt = 0;
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) { aoHiddenAt = Date.now(); }
    else if (aoHiddenAt && Date.now() - aoHiddenAt > 5 * 60 * 1000) { aoFreshReset(); aoFreshRun(); }
  });
  // Expose for diagnostics/tests
  window.AOFresh = { fetch: aoFreshFetch, card: aoFreshCard, scan: aoFreshScan, pdp: aoFreshPDP, reset: aoFreshReset };

  /* ---------------- Floating pill ---------------- */
  var pill = document.querySelector('[data-ao-pill]');
  var currentPillCard = null;
  var pillTimer = null;

  function fillPill(card) {
    if (!pill) return;
    var d = card.dataset;
    currentPillCard = card;
    var img = pill.querySelector('[data-ao-pill-img]');
    var name = pill.querySelector('[data-ao-pill-name]');
    var price = pill.querySelector('[data-ao-pill-price]');
    var link = pill.querySelector('[data-ao-pill-link]');
    var btn = pill.querySelector('[data-ao-pill-btn]');
    if (img) { img.src = d.image || ''; }
    if (name) { name.textContent = d.title || ''; name.href = d.url || '#'; }
    if (link) link.href = d.url || '#';
    if (price) price.textContent = d.price || '';
    // mirror data onto the pill button for cardAction()
    btn.setAttribute('data-simple', d.simple);
    btn.setAttribute('data-available', d.available);
    btn.setAttribute('data-variant', d.variant);
    btn.setAttribute('data-url', d.url);
    if (d.available !== 'true') { btn.textContent = STR.soldout; btn.disabled = true; btn.classList.add('is-soldout'); }
    else { btn.disabled = false; btn.classList.remove('is-soldout'); btn.textContent = d.simple === 'true' ? STR.add : STR.options; }
  }
  function showPill() { if (pill) { pill.hidden = false; requestAnimationFrame(function () { pill.classList.add('is-on'); }); } }
  function hidePill() { if (pill) { pill.classList.remove('is-on'); } }

  var hoverFine = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (pill) {
    if (hoverFine) {
      document.addEventListener('mouseover', function (e) {
        var card = e.target.closest('[data-ao-card]');
        if (card) { clearTimeout(pillTimer); fillPill(card); showPill(); }
      });
      document.addEventListener('mouseout', function (e) {
        if (e.target.closest('[data-ao-pill]')) return;
        var to = e.relatedTarget;
        if (to && (to.closest('[data-ao-card]') || to.closest('[data-ao-pill]'))) return;
        clearTimeout(pillTimer);
        pillTimer = setTimeout(hidePill, 400);
      });
      pill.addEventListener('mouseenter', function () { clearTimeout(pillTimer); });
      pill.addEventListener('mouseleave', function () { pillTimer = setTimeout(hidePill, 400); });
    } else if ('IntersectionObserver' in window) {
      // Touch: surface the most-visible card in the bar
      var cards = document.querySelectorAll('[data-ao-card]');
      if (cards.length) {
        var io = new IntersectionObserver(function (entries) {
          var best = null, bestRatio = 0;
          entries.forEach(function (en) { if (en.intersectionRatio > bestRatio) { bestRatio = en.intersectionRatio; best = en.target; } });
          if (best && bestRatio > 0.5) { fillPill(best); showPill(); }
        }, { threshold: [0, 0.5, 1], rootMargin: '-30% 0px -30% 0px' });
        cards.forEach(function (c) { io.observe(c); });
      }
    }
  }

  /* ---------------- PDP sticky add-to-cart bar ---------------- */
  var sticky = document.querySelector('[data-ao-stickybar]');
  if (sticky) {
    var mainBtn = document.querySelector('.product-form__submit') ||
      document.querySelector('product-form button[type="submit"]');
    var stickyAdd = sticky.querySelector('[data-ao-sticky-add]');
    var stickyPrice = sticky.querySelector('[data-ao-sticky-price]');
    var mainPrice = document.querySelector('.product__info-wrapper .price, .product__info-container .price');

    sticky.hidden = false;
    if (mainBtn && 'IntersectionObserver' in window) {
      var sio = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { sticky.classList.toggle('is-on', !en.isIntersecting); });
      }, { rootMargin: '0px 0px -40px 0px' });
      sio.observe(mainBtn);
    }
    if (stickyAdd) {
      stickyAdd.addEventListener('click', function () {
        if (!mainBtn) return;
        if (mainBtn.disabled) return;
        mainBtn.click(); // reuse Dawn's variant validation + AJAX add + cart drawer
      });
    }
    if (mainPrice && stickyPrice) {
      var sync = function () {
        var t = (mainPrice.querySelector('.price-item--sale:not(.hidden)') || mainPrice.querySelector('.price-item--regular') || mainPrice).textContent;
        if (t) stickyPrice.textContent = t.trim();
        if (mainBtn) {
          var soldout = mainBtn.disabled;
          stickyAdd.disabled = soldout;
          stickyAdd.textContent = soldout ? STR.soldout : STR.add;
        }
      };
      var smo = new MutationObserver(sync);
      smo.observe(mainPrice, { childList: true, subtree: true, characterData: true });
      if (mainBtn) smo.observe(mainBtn, { attributes: true, childList: true, subtree: true });
      sync();
    }
  }
})();

/* ============================================================
   Infinite scroll for collection / search grids
   Driven by page number (Dawn swaps prev/next arrow classes, so we don't
   rely on them). Preserves filters/sort (uses current URL params), de-dupes,
   keeps lazy images, and is compatible with the delegated AJAX add + hover.
   ============================================================ */
(function () {
  'use strict';
  var grid = document.getElementById('product-grid');
  if (!grid || grid.tagName !== 'UL') return;
  var wrap = document.querySelector('.pagination-wrapper');
  if (!wrap) return; // single page → nothing to load
  var current = parseInt(wrap.getAttribute('data-page'), 10) || 1;
  var nums = [].map.call(wrap.querySelectorAll('.pagination__list a, .pagination__list span'), function (e) {
    return parseInt((e.textContent || '').trim(), 10);
  }).filter(function (n) { return !isNaN(n); });
  var lastPage = nums.length ? Math.max.apply(null, nums) : current;
  if (current >= lastPage) return;

  wrap.style.display = 'none';
  var isAr = (document.documentElement.getAttribute('dir') || '').toLowerCase() === 'rtl';
  var END_TXT = isAr ? 'لقد وصلت إلى النهاية' : "You've reached the end";

  var seen = {};
  [].forEach.call(grid.querySelectorAll('a[href*="/products/"]'), function (a) {
    seen[a.getAttribute('href').split('?')[0]] = 1;
  });

  var status = document.createElement('div');
  status.className = 'ao-inf-status';
  status.setAttribute('role', 'status');
  status.setAttribute('aria-live', 'polite');
  var sentinel = document.createElement('div');
  sentinel.className = 'ao-inf-sentinel';
  /* Anchor right after the grid (the pagination-wrapper is now display:none,
     so anchoring to it would collapse the sentinel to the top of the page). */
  var anchorHost = grid.parentNode;
  anchorHost.insertBefore(status, grid.nextSibling);
  anchorHost.insertBefore(sentinel, status);

  var loading = false;
  var done = false;
  function setLoading(on) { status.innerHTML = on ? '<span class="ao-inf-spinner" aria-hidden="true"></span>' : ''; }
  function finish() { done = true; status.innerHTML = '<span class="ao-inf-end">' + END_TXT + '</span>'; window.removeEventListener('scroll', onScroll); }

  function loadNext() {
    if (loading) return;
    if (current >= lastPage) { finish(); return; }
    loading = true;
    setLoading(true);
    var u = new URL(window.location.href);
    u.searchParams.set('page', current + 1);
    fetch(u.toString(), { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var ng = doc.getElementById('product-grid');
        var items = ng ? ng.querySelectorAll('li.grid__item') : [];
        var added = 0;
        [].forEach.call(items, function (li) {
          var a = li.querySelector('a[href*="/products/"]');
          var key = a ? a.getAttribute('href').split('?')[0] : null;
          if (key && seen[key]) return;
          if (key) seen[key] = 1;
          grid.appendChild(li);
          added++;
        });
        current++;
        loading = false;
        setLoading(false);
        if (current >= lastPage || added === 0) { finish(); }
        else { setTimeout(onScroll, 60); } // keep filling if still near the bottom
      })
      .catch(function () { loading = false; setLoading(false); });
  }

  /* Trigger by scroll position (robust regardless of sentinel layout). */
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      ticking = false;
      if (loading || done) return;
      var nearBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight - 800;
      if (nearBottom) loadNext();
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();
})();

/* ============================================================
   Free shipping progress bar — animate the fill on mount.
   The bar is re-rendered server-side by Dawn on every cart change
   (#CartDrawer + cart page .js-contents) and by our own refreshCart;
   we just replay the width transition whenever a fresh .ao-fsb appears.
   ============================================================ */
(function () {
  function animate(bar) {
    if (!bar) return;
    var fill = bar.querySelector('.ao-fsb__fill');
    if (!fill) return;
    var pct = parseFloat(bar.getAttribute('data-pct'));
    if (isNaN(pct)) pct = 0;
    if (pct > 100) pct = 100;
    if (pct < 0) pct = 0;
    // start from 0 without transition, then transition to target
    fill.style.transition = 'none';
    fill.style.width = '0%';
    void fill.offsetWidth; // force reflow
    fill.style.transition = '';
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        fill.style.width = pct + '%';
      });
    });
  }
  function animateAll(root) {
    (root || document).querySelectorAll('.ao-fsb').forEach(animate);
  }

  function init() {
    animateAll();

    // Re-animate whenever a fresh bar is injected (any cart re-render source).
    if ('MutationObserver' in window) {
      var obs = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          var nodes = mutations[i].addedNodes;
          for (var j = 0; j < nodes.length; j++) {
            var n = nodes[j];
            if (n.nodeType !== 1) continue;
            if (n.classList && n.classList.contains('ao-fsb')) animate(n);
            else if (n.querySelector) {
              var b = n.querySelector('.ao-fsb');
              if (b) animate(b);
            }
          }
        }
      });
      obs.observe(document.body, { childList: true, subtree: true });

      // Replay when the cart drawer opens (content already current, just animate).
      var cd = document.querySelector('cart-drawer');
      if (cd) {
        var cdObs = new MutationObserver(function () {
          if (cd.classList.contains('active') || cd.classList.contains('animate')) {
            animateAll(cd);
          }
        });
        cdObs.observe(cd, { attributes: true, attributeFilter: ['class'] });
      }
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();

/* ============================================================
   Move the BEAST/Doubly currency switcher from its floating
   position into the footer slot (#ao-currency-footer). The app
   only populates the .doubly-float it creates itself, so we let
   it build the floating widget, then relocate the populated node.
   ============================================================ */
(function () {
  function placed(w) { return w && w.classList.contains('ao-in-footer'); }
  function tryPlace() {
    var slot = document.getElementById('ao-currency-footer');
    if (!slot) return false;
    var w = document.querySelector('body > .doubly-float');
    if (!w) return false;
    // Wait until the app has populated + enhanced it (select / styled dropdown present).
    if (!w.querySelector('.doubly-nice-select, select.currency-switcher')) return false;
    slot.appendChild(w);
    w.classList.add('ao-in-footer');
    return true;
  }
  function init() {
    if (tryPlace()) return;
    if (!('MutationObserver' in window)) return;
    var obs = new MutationObserver(function () {
      var w = document.querySelector('.doubly-float');
      if (placed(w)) { obs.disconnect(); return; }
      if (tryPlace()) obs.disconnect();
    });
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 15000);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
